export const ALLPERMISSIONS = 1
